import React from "react";

const Tile = () => {
  return (
    <>
      <section id="about-us" className="py-2">
      <div className="container">
        <div className="two-card-container">
          <article className="card">
            <div className="director-photo">
            <img
                src={
                  "../Images/articles/tile_main1.jpg"
                }
                alt="Tile"
                className="article-img"
              />
            <img
                src={
                  "../Images/articles/tile_main2.jpg"
                }
                alt="Tile"
                className="article-img"
              />
            </div>
          </article>
          <article className="card">
          <h2>Tiles</h2>
            <p>
            Tile flooring offers unmatched durability, making it an excellent choice for areas with high foot traffic or moisture-prone spaces like kitchens and bathrooms. Its sturdy composition ensures that it can withstand daily wear and tear, including scratches, stains, and spills. With tile flooring, you can have peace of mind knowing that your floors will maintain their beauty and functionality for years to come.
            </p>
            <br />
            <p>
            Tile flooring offers unmatched durability, making it an excellent choice for areas with high foot traffic or moisture-prone spaces like kitchens and bathrooms. Its sturdy composition ensures that it can withstand daily wear and tear, including scratches, stains, and spills. With tile flooring, you can have peace of mind knowing that your floors will maintain their beauty and functionality for years to come.
            </p>
            <br />
            <p>
            Tile flooring is highly resistant to moisture, making it an ideal choice for areas prone to spills or humidity. Unlike other flooring options, tiles do not absorb liquids, which helps prevent the growth of mold and mildew. This moisture resistance makes tile flooring easy to clean and maintain, ensuring a hygienic and healthy environment for you and your family.
            </p>
            <br />
          </article>
        </div>
      </div>
    </section>
    </>
  );
};

export default Tile;